import styled from "styled-components";

export const Wrapper = styled.div`
  .content-button{
    .icon{
      width: auto !important;
      height: 14px !important;
    }
 }
`
